module.exports = __webpack_public_path__ + "static/media/twointwo.4ae6a25d.jpg";